export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "pageTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer Sign In"])},
        "createAccount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create account"])},
        "loginToExisting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Already have an account?"])}
      },
      "de": {
        "pageTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundenanmeldung"])}
      }
    }
  })
}